import { Moon, Sun, Palette } from "lucide-react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import { useTheme, type Theme } from "~/lib/theme";

const THEMES: ReadonlyArray<{ value: Theme; label: string; swatch: string }> = [
    { value: "dataflowx", label: "DataFlowX", swatch: "#EAAA00" },
    { value: "ember", label: "Ember", swatch: "#C03020" },
];

export function ThemeToggle(): React.ReactElement {
    const { theme, mode, setTheme, toggleMode } = useTheme();

    return (
        <div className="cluster-xs">
            <button
                type="button"
                onClick={toggleMode}
                aria-label={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"}
                title={mode === "dark" ? "Light mode" : "Dark mode"}
                className="btn btn--ghost btn--sm press-crush"
            >
                {mode === "dark" ? <Sun size={16} /> : <Moon size={16} />}
            </button>

            <DropdownMenu.Root>
                <DropdownMenu.Trigger asChild>
                    <button
                        type="button"
                        aria-label="Pick theme"
                        title="Theme"
                        className="btn btn--ghost btn--sm press-crush"
                    >
                        <Palette size={16} />
                    </button>
                </DropdownMenu.Trigger>
                <DropdownMenu.Portal>
                    <DropdownMenu.Content
                        align="end"
                        sideOffset={6}
                        className="surface-raised enter-up p-1 min-w-[180px] z-popover"
                    >
                        {THEMES.map((t) => (
                            <DropdownMenu.Item
                                key={t.value}
                                onSelect={() => setTheme(t.value)}
                                className="cmdbar__item text-13"
                                data-active={t.value === theme || undefined}
                            >
                                <span
                                    aria-hidden
                                    style={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: 9999,
                                        background: t.swatch,
                                        flexShrink: 0,
                                    }}
                                />
                                <span>{t.label}</span>
                                {t.value === theme && (
                                    <span className="cmdbar__item__hint">active</span>
                                )}
                            </DropdownMenu.Item>
                        ))}
                    </DropdownMenu.Content>
                </DropdownMenu.Portal>
            </DropdownMenu.Root>
        </div>
    );
}
